<template>
  <div class="business">
    <div class="top-bar">
      <span @click="goBackToDepartmentIntroPage">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{heading}}</span>
    </div>

    <toast-message
    :message="errmsg"
    :isToastEnable="toast"
    type="error"
    @close="(val) => toast = val"
    />

    <div class="content-new" v-if="!editMode">
      <tl-radio
        name="uploadMethod"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />
      <tl-radio
        name="uploadMethod"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      />
    </div>

    <div class="margin-l-l" :class="{'content-new': editMode}">
      <div class="bulkUploadClass" v-if="uploadMethod == 'bulkUpload'">
        <div class="download-btn">
          <div class="download-btn-container">
            <img src="@/assets/download.svg"  class="img" />
            <span class="text" @click="downloadUrl">Download Template</span>
            <loading-animation v-show="showLoader"></loading-animation>
         </div>
        </div>
        <div class="margin-t-15px">
          <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
        </div>
      </div>
      <section class="singleColumnGrid" v-if="uploadMethod == 'manualUpload'">
        <txt
          autofocus="autofocus"
          label='Name *'
          type="text"
          v-model='formData.name'
          placeholder="Department Name"
          name="Department Name"
          v-validate="'required'"
          @onValueChange="save"
          :classname="errors.has('Department Name')"
          :errormsg = "errors.first('Department Name')"
          />
        <txt
          autofocus="autofocus"
          label="Code *"
          type="text"
          placeholder="Enter Code"
          v-model="formData.code"
          @onValueChange="save"
          name="Code"
          data-vv-as="code"
          v-validate="{required: true, max: 8}"
          :classname="errors.has('Code')"
          :errormsg="errors.first('Code')"
          />
        <txt
          autofocus="autofocus"
          label='Description'
          type="textarea"
          placeholder="Description"
          v-model='formData.description'
          name="DepartmentDescription"
          rows="6"
          @onValueChange="save"
          />
      </section>

<!-- <div class="upload">
                <p></p>
                <p>Drag & drop files here</p>
                <p>Or</p>
                <div class="upload-button">
                    <img src="@/assets/logout-copy-2_2@2x.png" alt>
                    <label for="upload-photo">Browse</label>
                    <input type="file" name="photo" id="upload-photo">
                </div>
</div> -->

  </div>
  <footer>
  <toast-message :message="errmsg" v-show="toast" type="error"/>
    <pop-up-message v-if="showSuccessMsg"
      :message="`${formData.name} Department has been successfully ${editMode ? 'updated' : 'created'}.`"
      btnText="Back to Departments List"
      @back="gotoDepartmentsList()"
      />
  <bottom-action-container class="position-fixed marginleft">
      <btn-grp slot="end">
        <btn text="Cancel" type="secondary" @click="goBackToDepartmentIntroPage" />
        <btn :text="btnText" type="primary" v-on:click="save"></btn>
      </btn-grp>
  </bottom-action-container>
  </footer>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { createDecipheriv } from 'crypto';
import { api_variables } from "@/apis/variables.js";
import axios from "axios";
import {S3} from "aws-sdk";
export default {
  name: "AddDepartment",
  data() {
    return {
      showLoader: false,
      bulkUploadTemplateUrl:"https://paylief.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Department.xlsx",
      bulkUploadUrl: api_variables.SERVICE_DEPARTMENT_UPLOAD_TEMPLATE,
      emptyFormData: {
        name: "",
        code: "",
        description: ""
      },
      formData: {
        name: "",
        code: "",
        description: ""
      },
      errmsg: "",
      popupMessage: "",
      showSuccessMsg: false,
      toast: false,
      uploadMethod: "manualUpload"
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/departments/record",
      editMode: "onboard/departments/editMode"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add Department";
      }
    },
    isEditMode() {
      return this.mode == "edit";
    },
    heading() {
      if (this.editMode) {
        return "Edit Department - " + this.formData.name;
      } else {
        return "Add Department";
      }
    }
  },
  activated() {
    this.toast = false;
    this.uploadMethod = "manualUpload";
    if (this.editMode) {
      this.formData = this.record;
    } else {
      this.formData = {
        name: "",
        code: "",
        description: ""
      };
    }
  },
  methods: {
    ...mapActions("onboard/departments/", {
      act_create: "create",
      act_update: "update"
    }),
    ...mapActions("payroll/lopsandrlops/", {
    getPreSignedUrl: "createPreSigned"
  }),
  async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.bulkUploadTemplateUrl
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},
    async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Department.xls"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          console.log('Failed to retrieve the download link.');
        }
      } catch (e) {
        console.error('Error during download:', e);
      }
    },
    async decrypt(payload){
    const key = process.env.VUE_APP_PAYSLIP_SECRET;
    const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
    const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
    ]);

    return decrypted.toString();
},
    
    gotoDepartmentsList() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${
          this.$route.params.entity_index
        }/departments`
      });
    },

    async performAction() {
      try {
        if (this.editMode) {
          this.$root._data.isSaving = true;
          this.formData.name = this.formData.name.toString().trim();
          this.formData.id = this.record.id;
          let res = await this.act_update([this.formData, this.le_id]);
          if (res.data.status) {
            this.showSuccessMsg = true;
            setTimeout(() => {
              this.$root._data.isSaving = false;
            }, 500);
          }
        } else {
          this.$root._data.isSaving = true;
          let res = await this.act_create({
            data: { ...this.formData, le_id: this.le_id }
          });
          if (res.data.status) {
            this.showSuccessMsg = true;
            setTimeout(() => {
              this.$root._data.isSaving = false;
            }, 500);
          }
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to get response after uploading in bulk */
    async onUploadTemplate(res) {
      try {
          if (res.data && res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessBulkUploadMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.response.data.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    goBackToDepartmentIntroPage() {
      this.$router.push({
        path: `/onboarding/entity/${
          this.$route.params.entity_index
        }/departments`
      });
    },

    refresh() {
      this.formData = this.$_.cloneDeep(this.emptyFormData);
      this.$validator.reset();
    },

    async save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction().then(() => {});
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../../scss/variables";
.download-btn-container {
  display: flex;
  align-items: normal;
  margin-bottom:-40px;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: $color-secondary;
    margin-left: 8px;
    cursor: pointer;
  }
}
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}
bottom-action-container.position-fixed {
  position: fixed;
}
.business {
  width: 100%;
  height: 100%;
  .top-bar {
    height: 64px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
    }
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      lightgray 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}

.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}

.refresh-icon {
  cursor: pointer;
}

.errorr {
  border: 1px solid #e01717;
}
.errorMessage {
  color: #e01717;
  // padding-top: 1px
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.content-new {
  margin: 32px 32px;
  display: flex;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
    // padding-top: 1px
  }
}

.marginleft {
  margin-left: 32px;
}
</style>
